import moment from 'moment';
import { browserHistory } from 'react-router'
import {
  SET_BUSINESS_ALL_DETAIL,
  FILTER_BUSINESS_LIST,
  SET_BUSINESS_DETAIL_FROM_LIST,
  BUSINESS_PROFILE_IMAGE_FILE_SUPER,
  HANDLE_REQUEST_CLOSE_BUSINESS_PROFILE
} from '../constants/ActionTypes';

const INIT_STATE = {
  allData: [],
  currentData: [],
  filter: {
    startDate: null,
    endDate: null,
    status: undefined,
    employee: undefined,
  },
  toggle: false,
  errorMessage: false,
  successMessage: false,
  alertMessage: "",
  data: null,
  imageFile: null,
  imageid:""
}

export default (state = INIT_STATE, { type, payload }) => {
  switch(type) {
    case SET_BUSINESS_ALL_DETAIL:
      return { ...state, allData: payload, currentData: payload, data: null, imageFile: null };
    case FILTER_BUSINESS_LIST: 
      const { allData } = state;
      const currentData = allData.filter(item => {
        const {
          name,
          owner_details : {
            firstname,
            lastname
          },
          business_type,
          business_locations
        } = item;
        const owner_name = `${firstname} ${lastname}`;
        return (
          name.toLowerCase().indexOf(payload.trim().toLowerCase()) > -1 ||
          owner_name.toLowerCase().indexOf(payload.trim().toLowerCase()) > -1 ||
          business_type[0].name.toLowerCase().indexOf(payload.trim().toLowerCase()) > -1
        );
      });

      return { ...state, currentData };
    case  SET_BUSINESS_DETAIL_FROM_LIST:
      return {...state, data: payload, imageFile: payload.imageFile};
    case BUSINESS_PROFILE_IMAGE_FILE_SUPER:
        let imageid = "";
        if(state.imageFile != null && state.imageFile._id != undefined) {
          imageid= state.imageFile._id;
        }
        if(state.imageid != "") {
          imageid= state.imageid;
        }
      return { ...state, imageFile: payload,imageid };
    case HANDLE_REQUEST_CLOSE_BUSINESS_PROFILE:
      return { ...state, data: null, imageFile: null }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./reducers/BusinessSuperAdminReducer.js